export const CATALOG_PATH = {
    root: "/psychologists",
    anyFilter: `/psychologists/:filter`,
    anyPageFilter: `/psychologists/:filter/:page`,
    anyPage: `/psychologists/:page`,
    online: "/consultation-psychologist-online",
    anyPageOnline: "/consultation-psychologist-online/:page",
} as const
